export enum AccountAttributesEnum {
    ACCURACYTIERS = 'accuracyTiers',
    APPS = 'apps',
    ASYNCEXPORTS = 'asyncexports',
    AUTOREVEAL = 'autoreveal',
    BOOLEAN = 'boolean',
    CSVEXPORT = 'csvexport',
    DATADOGSESSIONRECORDING = 'datadogsessionrecording',
    DYNAMICS = 'dynamics',
    FORMSINTEL = 'formsintel',
    HUBSPOT = 'hubspot',
    HUBSPOT_LITE = 'hubspot_lite',
    INBOXINTEL = 'inboxintel',
    INTERNATIONAL = 'international',
    MARKETO = 'marketo',
    NEWS = 'news',
    NEWSALERTS = 'newsalerts',
    OUTREACH = 'outreach',
    PROSPECT = 'prospect',
    RODAUTOEXPORT = 'rodautoexport',
    SALESFORCE = 'salesforce',
    SALESLOFT = 'salesloft',
    TECHEXPORTS = 'techexports',
    TECHNOGRAPHICS = 'technographics',
    TRIAL = 'trial',
    UNBOUNCE = 'unbounce',
    UNIVERSALSEARCH = 'universalsearch',
    UNLIMITED_EXPORTS = 'unlimitedExports',
    ZOHO = 'zoho',
}
